import { FormControl, TextField, Autocomplete, Snackbar, Alert, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../../../redux/api';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { stringifyJSONAttributes, stringToBooleanConversion } from '../../../utils/utilFunctions';
import { isInValidInput, sanitizeInput } from '../../../utils/validate';
import ErrorModal from '../../ItemProperties/Forms/FieldDataValidation/ErrorModal';
import SmartPasswordField from '../../../commonComponents/SmartPasswordField';
import CustomValueModal from './CustomValueModal';

const BridgeGateFTP = ({ connectionType, connectionDetails, handleBodyContent, direction }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const params = useSelector((state) => state.queryParams);
    const [accounts, setAccounts] = useState([]);
    const [account, setAccount] = useState('');
    const [tradingPartners, setTradingPartners] = useState([]);
    const [tradingPartner, setTradingPartner] = useState('');
    const [fileDirectory, setFileDirectory] = useState('');
    const [fileMask, setFileMask] = useState('');
    const [ssh, setSsh] = useState(false);
    const [deleteFile, setDeleteFile] = useState(false);
    const [decompression, setDecompression] = useState(false);
    const [showDecompressionDir, setShowDecompressionDir] = useState(false);
    const [decompressionDir, setDecompressionDir] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState('');
    const [fileName, setFileName] = useState('');
    const [content, setContent] = useState(null);
    const [errorModal, setErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [compression, setCompression] = useState(false);
    const [compressionList, setCompressionList] = useState([]);
    const [compressionType, setCompressionType] = useState('');
    const [fileNameZip, setFileNameZip] = useState('');
    const [showDestinationPassword, setShowDestinationPassword] = useState(false);
    const [destinationPassword, setDestinationPassword] = useState('');
    const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });
    const [openCustomModal, setOpenCustomModal] = useState(false);
    const [currentValue, setCurrentValue] = useState("");
    const [modalType, setModalType] = useState("Account Value");

    const handleAlertClose = () => {
        setShowAlert({ ...showAlert, isOpen: false });
    }

    const debouncedContentUpdate = debounce(handleBodyContent, 500);

    const onInputChange = (name, value) => {
        if (name === 'ZIP_PASSWORD') {
            setContent((prev) => {
                return { ...prev, [name]: value };
            });
        } else {
            setContent((prev) => {
                return { ...prev, [name]: value };
            });
        }
    }

    const getTradingPatners = (acc) => {
        dispatch(api.endpoints.getTradingPatners.initiate({ account: acc })).then((response) => {
            if (response?.isSuccess) {
                const tradingPartners = ['-- Select --', 'ALL', ...response?.data?.data?.trading_partners]
                setTradingPartners(tradingPartners);
            } else setTradingPartners([]);
        });
    }

    const handleBlur = () => {
        const res = isInValidInput(fileName);
        if (res.inValid) {
            setErrorModal(true);
            setErrorMessage(res.message);
        } else {
            setErrorModal(false);
            setErrorMessage(res.message);
        }
    }

    const inputConverter = () => {
        const sanitizeResult = sanitizeInput(fileName);
        onInputChange('FILENAME', sanitizeResult);
        setFileName(sanitizeResult);
        setErrorModal(false);
        setErrorMessage('');
    }

    function setCustomValue(value){
        if(modalType === "Account Value"){
            onInputChange('ACCOUNT', value);
            setAccount(value);
        } else if(modalType === "Trading Partner Value"){
            onInputChange('TRADING_PARTNER_NAME', value);
            setTradingPartner(value);
        }
    }

    useEffect(() => {
        debouncedContentUpdate(content);
    }, [content]);

    useEffect(() => {
        getTradingPatners(account);
    }, [account]);

    useEffect(() => {
        if (connectionType === t('BridgeGateFTP')) {
            dispatch(api.endpoints.getAccounts.initiate()).then((response) => {
                if (response?.data?.current_state === "SUCCESS") {
                    setAccounts(response?.data?.data?.accounts);
                } else setAccounts([]);
            });
            getTradingPatners(params.account);
        }
    }, [connectionType]);

    useEffect(() => {
        const { ACCOUNT, TRADING_PARTNER_NAME, FILENAMEMASK, FILE_LOCATION, DELETE, SSH, USE_ZIP_PASSWORD, ZIP_PASSWORD, DECOMPRESSION_DIRECTORY, SPECIFY_DECOMPRESSION_DIRECTORY } = connectionDetails;
        setAccount(ACCOUNT || '');
        setTradingPartner(TRADING_PARTNER_NAME || '-- Select --');
        setFileDirectory(FILE_LOCATION || '');
        setFileMask(FILENAMEMASK || '');
        setSsh(stringToBooleanConversion(SSH));
        if (DELETE) {
            if (stringToBooleanConversion(DELETE)) setDeleteFile(false);
            else setDeleteFile(true);
        } else setDeleteFile(false);
        if (direction === 'IN') {
            if (connectionDetails?.ZIP === 'ZIP' && direction === 'IN') setDecompression(true);
            else setDecompression(false);
            setShowPassword(stringToBooleanConversion(USE_ZIP_PASSWORD));
            setDecompressionDir(DECOMPRESSION_DIRECTORY || '');
            if ((DECOMPRESSION_DIRECTORY && DECOMPRESSION_DIRECTORY?.length !== 0) || stringToBooleanConversion(SPECIFY_DECOMPRESSION_DIRECTORY)) setShowDecompressionDir(true);
            else setShowDecompressionDir(false);
            if (ZIP_PASSWORD) {
                setPassword(ZIP_PASSWORD);
            }
            setPassword(ZIP_PASSWORD || '');
        }
        if (direction === 'OUT') {
            setCompression(stringToBooleanConversion(connectionDetails?.COMPRESSION) || false);
            setFileName(connectionDetails?.FILENAME || connectionDetails?.FILENAMEMASK || '');
            setCompressionType(connectionDetails?.COMPRESSION_TYPE || 'ZIP');
            setFileNameZip(connectionDetails?.FILE_NAME_WITHIN_ZIP || '');
            setShowDestinationPassword(stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD));
            if (stringToBooleanConversion(connectionDetails?.COMPRESSION)) setDestinationPassword(connectionDetails?.ZIP_PASSWORD || '');
        }
        setContent({ ...connectionDetails });
    }, [connectionDetails]);

    useEffect(() => {
        if (direction === 'OUT') {
            dispatch(api.endpoints.getCompressionList.initiate()).then((res) => {
                if (res?.data?.current_state === 'SUCCESS') {
                    const types = Object.values(res?.data?.data)?.map((item) => item?.TYPE)
                    setCompressionList(types);
                }
                if (res?.data?.current_state === 'ERROR') {
                    setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'error' });
                }
            });
        }
    }, [direction]);

    return (
        <>
            <div className="flex" style={{ flex: "1", width: "100%" }}>
                <Autocomplete
                    disablePortal
                    options={accounts}
                    value={account}
                    freeSolo
                    sx={{ maxHeight: 300, width: "100%", marginRight: "4px" }}
                    onChange={(e, value) => {
                        onInputChange('ACCOUNT', value);
                        setAccount(value);
                    }}
                    renderInput={(params) => <TextField
                        {...params}
                        label={t("ACCOUNT_")}
                        value={account}
                        onChange={(e) => {
                            onInputChange('ACCOUNT', e.target.value);
                            setAccount(e.target.value);
                        }}
                        variant="outlined"
                        size="small"
                        name={'ACCOUNT'}
                        autoComplete="off"
                    />
                    }
                />
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                        setModalType('Account Value');
                        setOpenCustomModal(true);
                        setCurrentValue(account);
                    }}
                    className="muiButtonHeight"
                    style={styles.popupBtn}
                >
                    {t("BTN_ABC")}
                </Button>
            </div>

            <div className="flex" style={{ flex: "1", width: "100%" }}>
                <Autocomplete
                    disablePortal
                    options={tradingPartners}
                    value={tradingPartner}
                    freeSolo
                    sx={{ maxHeight: 300, width: "100%", marginRight: "4px" }}
                    onChange={(e, value) => {
                        if (value !== '-- Select --') onInputChange('TRADING_PARTNER_NAME', value);
                        setTradingPartner(value);
                    }}
                    renderInput={(params) => <TextField
                        {...params}
                        label={t("LBL_TRADE_PARTNER_USER_NM")}
                        value={tradingPartner || tradingPartners[0]}
                        onChange={(event) => {
                            let value = event.target.value;
                            if (value !== '-- Select --') onInputChange('TRADING_PARTNER_NAME', value);
                            setTradingPartner(value);
                        }}
                        variant="outlined"
                        size="small"
                        name={'TRADING_PARTNER'}
                        autoComplete="off"
                    />
                    }
                />
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                        setModalType('Trading Partner Value');
                        setOpenCustomModal(true);
                        setCurrentValue(tradingPartner);
                    }}
                    className="muiButtonHeight"
                    style={styles.popupBtn}
                >
                    {t("BTN_ABC")}
                </Button>
            </div>
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_FILE_DIR")}
                    type="text"
                    value={fileDirectory}
                    onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setFileDirectory(e.target.value);
                    }}
                    className={"width-100"}
                    name={"FILE_LOCATION"}
                    autoComplete="off"
                />
            </FormControl>
            {direction === 'IN' && <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_FILE_NAME_MASK")}
                    type="text"
                    value={fileMask}
                    onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setFileMask(e.target.value);
                    }}
                    className={"width-100"}
                    name={"FILENAMEMASK"}
                    autoComplete="off"
                />
            </FormControl>}
            {direction === 'OUT' && <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_FILE_NAME")}
                    type="text"
                    value={fileName || ''}
                    onChange={(e) => {
                        onInputChange('FILENAME', e.target.value);
                        setFileName(e.target.value);
                    }}
                    onBlur={handleBlur}
                    className={"width-100"}
                    name={"FILENAME"}
                    autoComplete="off"
                />
            </FormControl>}
            {direction === 'IN' && <div className='flex flex-wrap'>
                <TPCheckbox
                    label={t("BTN_SSH")}
                    checked={ssh}
                    handleCheck={(checked) => {
                        onInputChange('SSH', stringifyJSONAttributes(checked));
                        setSsh(checked);
                    }}
                />
                <TPCheckbox
                    label={t("BTN_DO_NOT_DELETE")}
                    checked={deleteFile}
                    handleCheck={(checked) => {
                        onInputChange('DELETE', stringifyJSONAttributes(!checked));
                        setDeleteFile(checked);
                    }}
                />
                <TPCheckbox
                    label={t("BTN_USE_ZIP_DECOMPRESS")}
                    checked={decompression}
                    handleCheck={(checked) => {
                        if (checked) onInputChange('ZIP', 'ZIP');
                        else onInputChange('ZIP', '');
                        setDecompression(checked);
                        if (!checked) {
                            onInputChange('SPECIFY_DECOMPRESSION_DIRECTORY', stringifyJSONAttributes(false));
                            setShowDecompressionDir(false);
                            onInputChange('DECOMPRESSION_DIRECTORY', '');
                            setDecompressionDir('');
                            onInputChange('USE_ZIP_PASSWORD', stringifyJSONAttributes(false));
                            setShowPassword(false);
                            onInputChange('ZIP_PASSWORD', '');
                            setPassword('');
                        }
                    }}
                />
            </div>}
            {direction === 'OUT' && <div>
                <TPCheckbox
                    label={t("BTN_USE_ZIP_COMPRESS")}
                    checked={compression}
                    handleCheck={(checked) => {
                        onInputChange('COMPRESSION', stringifyJSONAttributes(checked));
                        setCompression(checked);
                        if (!checked) {
                            setCompressionType('ZIP');
                            onInputChange('COMPRESSION_TYPE', 'ZIP');
                            setFileNameZip('');
                            onInputChange('FILE_NAME_WITHIN_ZIP', '');
                            setShowDestinationPassword(false);
                            onInputChange('USE_ZIP_PASSWORD', stringifyJSONAttributes(false));
                            setDestinationPassword('');
                            onInputChange('ZIP_PASSWORD', '');
                        }
                    }}
                /></div>}
            {decompression && <>
                <div>
                    <TPCheckbox
                        label={t("LBL_SPECIFY_DECOMPRESSION_DIRECTORY")}
                        checked={showDecompressionDir}
                        handleCheck={(checked) => {
                            onInputChange('SPECIFY_DECOMPRESSION_DIRECTORY', stringifyJSONAttributes(checked));
                            setShowDecompressionDir(checked);
                            if (!checked) {
                                onInputChange('DECOMPRESSION_DIRECTORY', '');
                                setDecompressionDir('');
                            }
                        }}
                    />
                </div>
                {
                    showDecompressionDir && <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            label={t("LBL_DECOMPRESS_DIRECTORY")}
                            type="text"
                            value={decompressionDir || ''}
                            onChange={(e) => {
                                onInputChange(e.target.name, e.target.value);
                                setDecompressionDir(e.target.value);
                            }}
                            className={"width-100"}
                            name={"DECOMPRESSION_DIRECTORY"}
                            autoComplete="off"
                        />
                    </FormControl>
                }
                <div>
                    <TPCheckbox
                        label={t("LBL_WS_PASSWORD")}
                        checked={showPassword}
                        handleCheck={(checked) => {
                            onInputChange('USE_ZIP_PASSWORD', stringifyJSONAttributes(checked));
                            setShowPassword(checked);
                            if (!checked) {
                                setPassword('');
                                onInputChange('ZIP_PASSWORD', '');
                            }
                        }}
                    />
                </div>
                {showPassword && <SmartPasswordField
                    variant="outlined"
                    size="small"
                    label={t("LBL_WS_PASSWORD")}
                    value={password || ''}
                    onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setPassword(e.target.value);
                    }}
                    className={"width-100"}
                    name={"ZIP_PASSWORD"}
                    autoComplete="off"
                />}
            </>}
            {compression && direction === 'OUT' && <>
                <Autocomplete
                    disablePortal
                    options={compressionList}
                    getOptionLabel={(option) => option}
                    value={compressionType}
                    sx={{ maxHeight: 300 }}
                    onChange={(e, value) => {
                        onInputChange('COMPRESSION_TYPE', value);
                        setCompressionType(value);
                        if (['GZ', 'TAR', 'TGZ'].includes(value)) {
                            onInputChange('USE_ZIP_PASSWORD', stringifyJSONAttributes(false));
                            setShowDestinationPassword(false);
                            onInputChange('ZIP_PASSWORD', '');
                            setDestinationPassword('');
                        }
                    }}
                    renderInput={(params) => <TextField
                        {...params}
                        label={t("LBL_COMPRESSION_TYPE")}
                        onChange={(e) => {
                            const value = e.target.value;
                            onInputChange('COMPRESSION_TYPE', value);
                            setCompressionType(value);
                            if (['GZ', 'TAR', 'TGZ'].includes(value)) {
                                onInputChange('USE_ZIP_PASSWORD', stringifyJSONAttributes(false));
                                setShowDestinationPassword(false);
                                onInputChange('ZIP_PASSWORD', '');
                                setDestinationPassword('');
                            }
                        }}
                        variant="outlined"
                        size="small"
                        name={'COMPRESSION_TYPE'}
                        autoComplete="off"
                    />
                    }
                />
                <FormControl className="width-100" size="small">
                    <TextField
                        variant="outlined"
                        size="small"
                        label={t("FILE_NAME_WITHIN_ZIP")}
                        type="text"
                        value={fileNameZip || ''}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setFileNameZip(e.target.value);
                        }}
                        className={"width-100"}
                        name={"FILE_NAME_WITHIN_ZIP"}
                        autoComplete="off"
                    />
                </FormControl>
                {['JAR', 'RAR', 'ZIP'].includes(compressionType) && <>
                    <div>
                        <TPCheckbox
                            label={t("LBL_WS_PASSWORD")}
                            checked={showDestinationPassword}
                            handleCheck={(checked) => {
                                onInputChange('USE_ZIP_PASSWORD', stringifyJSONAttributes(checked));
                                setShowDestinationPassword(checked);
                                if (!checked) {
                                    onInputChange('ZIP_PASSWORD', '');
                                    setDestinationPassword('');
                                }
                            }}
                        />
                    </div>
                    {showDestinationPassword && <SmartPasswordField
                        variant="outlined"
                        size="small"
                        label={t("LBL_WS_PASSWORD")}
                        value={destinationPassword || ''}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setDestinationPassword(e.target.value);
                        }}
                        className={"width-100"}
                        name={"ZIP_PASSWORD"}
                        autoComplete="off"
                    />}
                </>}
            </>}
            <ErrorModal
                errorModal={errorModal}
                setErrorModal={() => setErrorModal(false)}
                errorMessage={errorMessage}
                OkHandler={inputConverter}
            />
            <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
                <Alert
                    onClose={() => handleAlertClose()}
                    severity={showAlert.type}
                    variant="filled"
                    sx={{ width: "100%" }}>
                    {showAlert.mssg}
                </Alert>
            </Snackbar>

            <CustomValueModal
            type={modalType}
            modalOpen={openCustomModal}
            currentValue={currentValue}
            setValue={setCustomValue}
            modalType={modalType}
            handleClose={() => setOpenCustomModal(false)} />
        </>
    )
}

export default BridgeGateFTP

const styles = {
    popupBtn: {
        minWidth: "32px",
    }
}